module.exports = __webpack_public_path__ + "static/media/verifiedbadge.d192f13b.svg";